import React from 'react';
import Data from './data';
import CandidatePage from 'pages/june-5/races/components/CandidatePage';
const Page = () => ( <CandidatePage data={Data}/>);
export default Page


// WEBPACK FOOTER //
// ./src/pages/june-5/races/data/SFMayor/mb/page.js